<template>
  <div class="download-center-page">
    <!-- Banner Section -->
    <section class="banner-section">
      <div class="banner-content">
        <h1 class="banner-title">{{ bannerTitle }}</h1>
      </div>
    </section>

    <!-- Software Download Section -->
    <section class="software-download-section">
      <div class="container">
        <h2 class="section-title">{{ sectionTitle }}</h2>
        <div class="software-grid">
          <div class="software-item"
               v-for="(item, index) in softwareList"
               :key="index">
            <div class="software-card">
              <div class="icon-wrapper">
                <img :src="item.icon"
                     :alt="item.name"
                     class="software-icon">
              </div>
              <p class="software-name">{{ item.name }}</p>
            </div>
            <a :href="item.downloadLink"
               class="download-btn"
               target="_blank"
               rel="noopener noreferrer">
              {{ downloadButtonText }}
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { softTableApi } from '@/api'

export default {
  name: 'DownloadCenter',
  data() {
    return {
      softLoaded: false,
      softItems: [],
      fallbackIcon:
        'https://images.unsplash.com/photo-1611162617474-5b21e879e113?auto=format&fit=crop&w=100&q=80'
    }
  },
  mounted() {
    this.loadSoftTable()
  },
  computed: {
    downloadCenterCopy() {
      const locale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'zh-CN'
      const messages =
        this.$i18n && this.$i18n.getLocaleMessage
          ? this.$i18n.getLocaleMessage(locale)
          : {}
      return (messages.support && messages.support.downloadCenter) || {}
    },
    bannerTitle() {
      return this.downloadCenterCopy.bannerTitle || ''
    },
    sectionTitle() {
      return this.downloadCenterCopy.sectionTitle || ''
    },
    downloadButtonText() {
      return this.downloadCenterCopy.downloadButtonText || ''
    },
    softwareList() {
      if (this.softLoaded) {
        return this.softItems
          .filter((item) => item && item.name)
          .map((item) => ({
            id: item.id,
            name: String(item.name || ''),
            icon: this.normalizeUrl(item.photoUrl) || this.fallbackIcon,
            downloadLink: encodeURI(this.normalizeUrl(item.url)),
            type: item.type || '',
            system: item.system || '',
            version: item.version || '',
            num: item.num || 0,
            createTime: item.createTime || '',
          }))
      }

      const list = this.downloadCenterCopy.softwareList || []
      return list.map((item) => ({
        name: item.name || '',
        icon: this.fallbackIcon,
        downloadLink: '#'
      }))
    }
  },
  methods: {
    normalizeUrl(url) {
      if (!url) return ''
      const str = String(url).trim()
      if (!str) return ''
      const noBackticks = str.replace(/`/g, '').trim()
      return noBackticks.replace(/^["']+|["']+$/g, '').trim()
    },
    async loadSoftTable() {
      try {
        const result = await softTableApi.selectAll()
        const ok =
          result &&
          (result.code === 200 ||
            result.success === true ||
            result.ok === true)
        const list = ok && Array.isArray(result.data) ? result.data : []
        this.softItems = list
        this.softLoaded = true
      } catch (e) {
        this.softLoaded = false
        this.softItems = []
      }
    },
  },
}
</script>

<style scoped>
.download-center-page {
  width: 100%;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

/* Banner Section */
.banner-section {
  width: 100%;
  height: 546px;
  background-image: url("@/assets/download/banner.png"); /* Light tech background */
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-content {
  text-align: center;
}

.banner-title {
  font-size: 48px;
  font-weight: bold;
  color: #333; /* Dark text based on user image context */
  margin: 0;
}

/* Software Download Section */
.software-download-section {
  width: 100%;
  height: 576px;
  background-color: #f4f6fa;
  padding-top: 80px; /* Adjust padding to center vertically or add spacing */
  box-sizing: border-box;
}

.container {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.section-title {
  font-size: 34px;
  color: #333;
  font-weight: bold;
  margin-bottom: 60px;
}

.software-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  justify-content: flex-start;
}

.software-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.software-card {
  width: 186px;
  height: 186px;
  background-color: #fff;
  border-radius: 12px; /* Assuming rounded corners */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;

}

.icon-wrapper {
  width: 88px;
  height: 88px;
  margin-bottom: 20px;
}

.software-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.software-name {
  font-size: 16px;
  color: #333;
  margin: 0;
  text-align: center;
}

.download-btn {
  width: 126px;
  height: 41px;
  background-color: #2ea2fa;
  border-radius: 21px;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: background-color 0.3s;
  cursor: pointer;
  border: none;
}

.download-btn:hover {
  background-color: #1a8ee6;
}
</style>
